/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react';
import { useState, useEffect } from 'react';

import cursorPointer32 from 'cursors/cursor-pointer-32.cur';

import cursorOnclick32 from 'cursors/cursor-onclick-32.cur';

import cursorDrag32 from 'cursors/cursor-drag-32.cur';

import cursorOnDrag32 from 'cursors/cursor-ondrag-32.cur';

import cursorText32 from 'cursors/cursor-text-32.cur';

import cursorDenied32 from 'cursors/cursor-denied-32.cur';

import cursorLoading128PNG from 'cursors/cursor-loading-128.png';

import { CURSOR_TYPES } from '~/lib/constants';

const CURSOR_OFFSETS = {
  [CURSOR_TYPES.POINTER]: {
    x: 12,
    y: 6 
  },
  [CURSOR_TYPES.ON_CLICK]: {  
    x: 12,
    y: 6 
  },
  [CURSOR_TYPES.DRAG] : {
    x: 12,
    y: 6 
  },
  [CURSOR_TYPES.ON_DRAG]: {
    x: 12,
    y: 6 
  },
  [CURSOR_TYPES.TEXT]: {
    x: 15,
    y: 10 
  },
  [CURSOR_TYPES.DENIED]: {
    x: 15,
    y: 10 
  },
  [CURSOR_TYPES.LOADING]: {
    x: 15,
    y: 10
  },
  default: {
    x: 0,
    y: 0
  }
};

export const PointerCursor = css`
    cursor: url(${cursorPointer32}) ${CURSOR_OFFSETS[CURSOR_TYPES.POINTER].x} ${CURSOR_OFFSETS[CURSOR_TYPES.POINTER].y}, pointer;
    
    &:active {
    cursor: url(${cursorOnclick32}) ${CURSOR_OFFSETS[CURSOR_TYPES.ON_CLICK].x} ${CURSOR_OFFSETS[CURSOR_TYPES.ON_CLICK].y}, pointer;
  }
`;

export const DragCursor = css`
    cursor: url(${cursorDrag32}) ${CURSOR_OFFSETS[CURSOR_TYPES.DRAG].x} ${CURSOR_OFFSETS[CURSOR_TYPES.DRAG].y}, pointer;

    &:active {
    cursor: url(${cursorOnDrag32}) ${CURSOR_OFFSETS[CURSOR_TYPES.ON_DRAG].x} ${CURSOR_OFFSETS[CURSOR_TYPES.ON_DRAG].y}, pointer;
  }
`;

export const TextCursor = css`
    cursor: url(${cursorText32}) ${CURSOR_OFFSETS[CURSOR_TYPES.TEXT].x} ${CURSOR_OFFSETS[CURSOR_TYPES.TEXT].y}, pointer;
`;

export const DeniedCursor = css`
    cursor: url(${cursorDenied32}) ${CURSOR_OFFSETS[CURSOR_TYPES.DENIED].x} ${CURSOR_OFFSETS[CURSOR_TYPES.DENIED].y}, not-allowed;
`;

const rotateAnimation = keyframes`
 from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoadingCursor = () => {
  const [position, setPosition] = useState({ x: window.mouseX ?? 0, y: window.mouseY ?? 0 });
  
  useEffect(() => {
    const updatePosition = (e) => {
      window.mouseX = e.clientX;
      window.mouseY = e.clientY;
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const handleInitialPosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
      window.removeEventListener('mousemove', handleInitialPosition);
    };
    
    window.addEventListener('mousemove', handleInitialPosition, { once: true });
    window.addEventListener('mousemove', updatePosition);
    return () => {
      window.removeEventListener('mousemove', updatePosition);
    };
  }, []);
  
  return (
    <div
      className='hide-cursor'
      css={css`
        position: fixed;
        left: ${position.x}px;
        top: ${position.y}px;
        width: 32px;
        height: 32px;
        pointer-events: none;
        cursor: none !important;
        z-index: 401;
        transform: translate(-50%, -50%);
        animation: ${rotateAnimation} 2s infinite linear;
      `}
    >
      <img 
        src={cursorLoading128PNG}
        className='hide-cursor'
        css={css`
          width: 100%;
          height: 100%;
          cursor: none;
        `}
        alt="cursor-loading"
      />
    </div>
  );
};
